import { z } from "zod";

// Query strings can't carry a real null, so an empty value means "no id".
export const zQueryNullableUuid = () =>
    z.union([
        z.literal(null),
        z.literal("").transform(() => null),
        z.string().uuid(),
    ]);
